import React from 'react';
import Data from './Data';

const CarouselSidebar = (props) => {
  return <Data {...props} />;
};

export default CarouselSidebar;
